export const KIND = {
  HAIRLINE: 'Hairline',
  DASHED: 'Dashed',
  SOLID: 'Solid',
  WIDE: 'Wide',
  SPACE: 'Space',
} as const

export const MARGIN = {
  DEFAULT: 'Regular',
  LARGE: 'Large',
  HALF: 'Half',
  SMALL: 'Small',
  NO: 'No',
} as const
